import { defineStore } from 'pinia'

import * as salesPlanApi from '../services/api/sales-plan'
import { IApproval } from './staff'

export interface ISalesPlanData {
  id: number
  is_urgent: boolean
  status: string
  approvals: Array<IApproval>
  month: string
  note: string
  target: string
  sell_targets: any
  purchasing_targets: any
  criteria_target: string
  kpi: any
  product_salary: any
  pay_off_selling: any
  pay_off_purchasing: string
  insurance_punishing: string
  commission_referral: any
  commission_bank: any
  punishment: string
  commission_accessory: any
  salary_purchasing: any
  salary_source: any
  commission_source: any
  punishment_purchasing: any
  salary_inspection: any
  punishment_inspection: any
  created_at: string
}

export const useSalesPlanStore = defineStore('salesPlan', {
  state: () => ({
    salesPlan: {
      id: 0,
      is_urgent: false,
      status: '',
      approvals: [],
      month: '',
      note: '',
      target: '',
      sell_targets: [],
      purchasing_targets: [],
      criteria_target: '',
      kpi: [],
      product_salary: [],
      pay_off_selling: [],
      pay_off_purchasing: '',
      insurance_punishing: '',
      commission_referral: [],
      commission_bank: [],
      punishment: '',
      commission_accessory: [],
      salary_purchasing: [],
      salary_source: [],
      commission_source: {},
      punishment_purchasing: [],
      salary_inspection: [],
      punishment_inspection: [],
      created_at: '',
    } as ISalesPlanData,
    isLoading: false,
  }),

  actions: {
    setSalesPlan(data: ISalesPlanData) {
      this.salesPlan = data
    },

    setLoading(value: boolean) {
      this.isLoading = value
    },

    async getSalesPlan(salesPlan_id: number) {
      try {
        this.setLoading(true)
        const { data } = await salesPlanApi.get(salesPlan_id)
        this.setSalesPlan(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async updateSalesPlan(payload: any) {
      try {
        this.setLoading(true)
        const { data } = await salesPlanApi.update(this.salesPlan.id, payload)
        this.setSalesPlan(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async applySalesPlan() {
      try {
        this.setLoading(true)
        const { data } = await salesPlanApi.apply(this.salesPlan.id)
        this.setSalesPlan(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async rejectSalesPlan(payload: any) {
      try {
        this.setLoading(true)
        const { data } = await salesPlanApi.reject(this.salesPlan.id, payload)
        this.setSalesPlan(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async remakeSalesPlan(payload: any) {
      try {
        this.setLoading(true)
        const { data } = await salesPlanApi.remake(this.salesPlan.id, payload)
        this.setSalesPlan(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async approveSalesPlan() {
      try {
        this.setLoading(true)
        const { data } = await salesPlanApi.approve(this.salesPlan.id)
        this.setSalesPlan(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },
  },
})

export const useSalesPlanListStore = defineStore('salesPlanList', {
  state: () => ({
    salesPlans: [] as ISalesPlanData[],
    count: 0,
    total: 0,
    isLoading: false,
  }),

  actions: {
    setCount(data: number) {
      this.count = data
    },

    setSalesPlans(data: ISalesPlanData[]) {
      this.salesPlans = data
    },

    setTotal(value: number) {
      this.total = value
    },

    setLoading(value: boolean) {
      this.isLoading = value
    },

    async countSalesPlans() {
      try {
        this.setLoading(true)
        const { data } = await salesPlanApi.count()
        this.setCount(data)
        this.setLoading(false)
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async listSalesPlans(params: any) {
      try {
        this.setLoading(true)
        const result = await salesPlanApi.list(params)
        const { data, total } = result as any
        this.setSalesPlans(data)
        this.setTotal(total)
        this.setLoading(false)
        return result
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },

    async listAllSalesPlans(params: any) {
      try {
        this.setLoading(true)
        const result = await salesPlanApi.listAll(params)
        const { data, total } = result as any
        this.setSalesPlans(data)
        this.setTotal(total)
        this.setLoading(false)
        return result
      } catch (e) {
        this.setLoading(false)
        throw new Error(String(e))
      }
    },
  },
})
